import React from "react";
import {useTranslation} from "react-i18next";
import {TableLabelCell, TableLabelHeader} from "../../common/CustomTable/CustomTable";
import ThirdPartyServiceModel from "../../../models/thirdparty/ThirdPartyServiceModel";
import ThirdPartyServiceTable from "../ThirdPartyServiceTable";

function InvestigateServiceTable(props) {

    return (
        <ThirdPartyServiceTable {...props} type={ThirdPartyServiceModel.Type.INVESTIGATE} showMethod showService
            TableHeaders={InvestigateServiceTableHeaders} TableRowCells={InvestigateServiceTableRowCells}
        />
    )
}

function InvestigateServiceTableHeaders() {
    const {t} = useTranslation(['thirdPartyService']);
    return (
        <>
            <TableLabelHeader label={t('thirdPartyService:label.url')}/>
        </>
    )
}

function InvestigateServiceTableRowCells(props) {
    const {
        thirdPartyService
    } = props;

    return (
        <>
            <TableLabelCell label={thirdPartyService.url}/>
        </>
    )
}

export default InvestigateServiceTable;
